// initial state
const state = {
  current: undefined,
  previous: undefined
}

// getters
const getters = {
  isCurrentRoute: state => name => state.current.name === name,
  isPreviousRoute: state => name => state.previous.name === name
}

const actions = {
  navigate: ({ commit }, { to, from }) => {
    if (to) {
      commit('setRoute', { property: 'current', route: to })
    }

    if (from) {
      commit('setRoute', { property: 'previous', route: from })
    }
  }
}

// mutations
const mutations = {
  setRoute (state, { property, route: { name, params } }) {
    state[property] = { name, params }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
